import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { OfflineProvider } from "./context/OfflineContext";
import { NotificationProvider } from "./context/NotificationContext";
import OfflineIndicator from "./components/ui/OfflineIndicator";
import Landing from "./pages/Landing";
import MetaRoute from "./pages/MetaRoute";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import BillingSuccess from "./pages/BillingSuccess";
import BillingCancel from "./pages/BillingCancel";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import AccountDeletion from "./pages/AccountDeletion";
import AdminPurge from "./pages/AdminPurge";
import DebugMilkRollup from "./pages/DebugMilkRollup";
import NotFound from "./pages/NotFound";
import "./App.css";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="animate-pulse text-muted-foreground">Loading...</div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="animate-pulse text-muted-foreground">Loading...</div>
      </div>
    );
  }
  
  if (user) {
    return <Navigate to="/app" replace />;
  }
  
  return children;
};

function App() {
  return (
    <AuthProvider>
      <OfflineProvider>
        <NotificationProvider>
          <BrowserRouter>
            <div className="min-h-screen bg-background">
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/pricing" element={<MetaRoute />} />
                <Route path="/features" element={<MetaRoute />} />
                <Route path="/about" element={<MetaRoute />} />
                <Route path="/customers" element={<MetaRoute />} />
                <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
                <Route path="/register" element={<PublicRoute><Register /></PublicRoute>} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/terms" element={<TermsOfService />} />
                <Route path="/account-deletion" element={<AccountDeletion />} />
                <Route path="/app/*" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                <Route path="/billing/success" element={<ProtectedRoute><BillingSuccess /></ProtectedRoute>} />
                <Route path="/billing/cancel" element={<ProtectedRoute><BillingCancel /></ProtectedRoute>} />
                <Route path="/admin-purge" element={<ProtectedRoute><AdminPurge /></ProtectedRoute>} />
                <Route path="/debug/milk-rollup" element={<ProtectedRoute><DebugMilkRollup /></ProtectedRoute>} />
                {/* Catch-all 404 */}
                <Route path="*" element={<NotFound />} />
              </Routes>
              <OfflineIndicator />
              <Toaster position="top-center" richColors />
            </div>
          </BrowserRouter>
        </NotificationProvider>
      </OfflineProvider>
    </AuthProvider>
  );
}

export default App;
